<template>
  <d2-container class="page">
    <el-row type="flex" align="center">
      <el-col :span="24">
        <div class="header" flex="main:justify cross:center">
          <div class="header__date" flex="cross:center">
            <el-button type="primary" size="mini" icon="el-icon-circle-plus" @click="add">添加二维码</el-button>
          </div>
          <div class="header__date" flex="cross:center">
            <el-select class="filter-item" v-model="sinaOpenId" placeholder="选择门店">
              <el-option
                v-for="item in mdOptions"
                :key="item.id"
                :label="item.shop_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="header__date" flex="cross:center">
            <el-input v-model="title" placeholder="请输入二维码名" width="20" />
          </div>
          <div class="header__date" flex="cross:center">
            <el-select class="filter-item" v-model="state" placeholder="状态" width="50">
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <el-button type="primary" icon="el-icon-search" size="mini"  @click="getTableData">搜索</el-button>
        </div>
      </el-col>
    </el-row>

    <el-row class="grow-bg">
      <div class="grow-bg__item" v-for="project in allprojects" :key="project.id">
        <div class="grow-bg__row" >
          <div class="grid-content bg-purple" flex="cross:center">
            <img :src="getImgUrl(project.imgurl)" style="width: 100px" />
            <div class="grow-bg__content">
              <div class="ellipsis">店名:{{project.shop_name}}</div>
              <div class="ellipsis">用户:{{project.username}}</div>
              <div class="ellipsis">名称:{{project.title}}</div>
              <div class="ellipsis">金额:{{project.amount}}</div>
              <div class="ellipsis">描述:{{project.describes}}</div>
            </div>
          </div>
          <div class="grow-bg__bt" flex="main:center">
            <el-button
              type="primary"
              v-if="project.state=='0'"
              plain
              size="mini"
              @click="update(project.id,1)"
            >设为禁用</el-button>
            <el-button
              type="primary"
              v-if="project.state=='1'"
              plain
              size="mini"
              @click="update(project.id,0)"
            >设为启用</el-button>
            <el-button type="primary" plain size="mini" @click="openEditForm(project)">修改</el-button>
          </div>
        </div>
      </div>
    </el-row>

    <edit-form :user="user" v-model="editFormVisible" @submit="getTableData" />
  </d2-container>
</template>

<script>
import util from '@/libs/util.js'
import editForm from './editForm'
import * as userService from '@/api/sys/user'
import * as agentService from '@/api/sys/agent'

export default {
  name: 'qrcodePage',
  components: { editForm },
  data () {
    return {
      order_amount: '',
      order_num: '',
      refund_amount: '',
      refund_num: '',
      yx_order_amount: '',
      commission_amount: '',
      payment_amount: '',
      discount_amount: '',
      agentid: '',
      sinaOpenId: '',
      state: '',
      title: '',
      mdOptions: [],
      allprojects: [],
      typeOptions: [
        {
          value: '0',
          label: '正常'
        },
        {
          value: '1',
          label: '禁用'
        }
      ],
      toolbox: {},
      user: {},
      editFormVisible: false
    }
  },
  mounted () {
    var formData2 = new FormData() // 声明一个FormData对象
    formData2.append('agentid', util.cookies.get('agentid'))
    agentService.getStoreagent(formData2).then(data => {
      this.mdOptions = data
    })
    this.getTableData()
  },
  methods: {
    getTableData () {
      var formData3 = new FormData() // 声明一个FormData对象
      formData3.append('agentid', util.cookies.get('agentid'))
      formData3.append('store_id', this.sinaOpenId)
      formData3.append('title', this.title)
      formData3.append('state', this.state)
      agentService.getStoreQrcode(formData3).then(data => {
        this.allprojects = data
      })
    },
    getImgUrl (row) {
      console.info('=========777777777777===============' + row)
      return 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + row
    },
    update (id, type) {
      let msg = type == 1 ? '禁用' : '恢复'
      this.$confirm('确认' + msg + '操作？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: msg,
        cancelButtonText: '取消'
      }).then(() => {
        userService.saveStoreQrcode({ id: id, state: type }).then(() => {
          this.getTableData()
        })
      })
    },
    add () {
      this.user = {}
      this.editFormVisible = true
    },
    openEditForm (user) {
      this.user = user
      this.editFormVisible = true
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  font-size: 12px;
  padding: 20px;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  &__picker {
    box-sizing: border-box;
  }
  &__date {
    height: 30px;
    margin: 0 10px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
  }
  &__date-row {
    padding: 0 0.2rem;
    height: 30px;
  }
  &__date-row--active {
    background-color: #409eff !important;
    color: #fff;
  }
  &__date-row:not(:last-child) {
    border-right: 1px solid #dcdfe6;
  }
}
</style>
<style lang="scss" scoped>
@import "./style.scss";
</style>
